﻿import { Injectable, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { TYPEMESSAGE } from '../common/constant.service';
import { SnackbarService } from '../snackbar/service/snackbar.service';

@Injectable()
export class NotificationService {
  constructor(public snackbarService: SnackbarService, private snackBar: MatSnackBar) { }

  // snackBar: MatSnackBar;

  public warning(msg: any) {
    this.snackbarService.warn(msg);
  }

  public information(msg: any) {
    this.snackbarService.info(msg);
  }

  public successful(msg: any) {
    this.snackbarService.success(msg);
  }

  public error(msg: any) {
    this.snackbarService.error(msg);
  }

  public confirmation(msg: any, event: Function = null, msgSi: string = 'Si', msgNo: string = 'No') {
    this.snackbarService.confirm(msg, event, msgSi, msgNo);
  }

  // public showMessage(msg: string, tipoMessage: number) {
  //   // tipoMessage => 1 = 'Correcto'
  //   // tipoMessage => 2 = 'Error'
  //   // tipoMessage => 3 = 'Informacion'
  //   // tipoMessage => 4 = 'Advertencia'
  //   let textButton: string;
  //   textButton = 'CERRAR';

  //   switch (tipoMessage) {
  //     case TYPEMESSAGE.Correcto:
  //       this.snackBar.open(msg, textButton, { duration: 4000, panelClass : ['successSnack'] });
  //       break;
  //     case TYPEMESSAGE.Error:
  //       this.snackBar.open(msg, textButton, { duration: 50000, panelClass: ['errorSnack'] });
  //       break;
  //     case TYPEMESSAGE.Informacion:
  //       this.snackBar.open(msg, textButton, { duration: 4000, panelClass: ['infoSnack'] });
  //       break;
  //     case TYPEMESSAGE.Advertencia:
  //       this.snackBar.open(msg, textButton, { duration: 4000, panelClass: ['alertSnack'] });
  //       break;
  //     default:
  //       this.snackBar.open(msg, textButton, { duration: 4000, panelClass: ['infoSnack'] });
  //       break;
  //   }
  // }
}
